import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { ContingentExportDialogComponent } from "./contingent-export-dialog.component";

@NgModule({
	declarations: [ContingentExportDialogComponent],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule, UserAvatarModule],
	exports: [ContingentExportDialogComponent],
})
export class ContingentExportDialogModule {}
